var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImmobilIconsDash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 92.716,
    height: 92.722,
    viewBox: "0 0 92.716 92.722",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_363",
    x: 0,
    y: 0,
    width: 92.716,
    height: 92.722,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_370",
    x: 8.77,
    y: 11.715,
    width: 26.808,
    height: 26.818,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_371",
    x: 20.51,
    y: 11.714,
    width: 26.807,
    height: 26.818,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_372",
    x: 43.927,
    y: 11.714,
    width: 26.803,
    height: 26.82,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_373",
    x: 32.233,
    y: 11.714,
    width: 26.782,
    height: 26.82,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_374",
    x: 32.232,
    y: 35.169,
    width: 26.783,
    height: 26.79,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_375",
    x: 8.773,
    y: 23.451,
    width: 26.81,
    height: 26.806,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_376",
    x: 20.505,
    y: 23.454,
    width: 26.811,
    height: 26.804,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-8"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_377",
    x: 32.231,
    y: 23.452,
    width: 26.784,
    height: 26.807,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-9"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_378",
    x: 43.926,
    y: 23.455,
    width: 26.807,
    height: 26.804,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-10"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-10"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_379",
    x: 43.927,
    y: 35.168,
    width: 26.803,
    height: 26.791,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-11"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-11"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_380",
    x: 8.768,
    y: 35.169,
    width: 26.814,
    height: 26.788,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-12"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-12"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_381",
    x: 20.506,
    y: 35.169,
    width: 26.812,
    height: 26.787,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-13"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-13"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_271",
    "data-name": "Groupe 271",
    transform: "translate(-15.41 -284.513)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 15.41, 284.51)",
    filter: "url(#Trac\\xE9_363)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_363-2",
    "data-name": "Trac\\xE9 363",
    d: "M24.41,298.279v-6.712a2,2,0,0,1,1.984-1.036q28.779.029,57.558.014c.146,0,.292,0,.437,0a1.423,1.423,0,0,1,1.532,1.429q.066,2.954,0,5.908a1.411,1.411,0,0,1-1.517,1.436c-.431.017-.863,0-1.344,0v20.532h.9q6.747,0,13.5,0a1.444,1.444,0,0,1,1.65,1.52q.03,2.881,0,5.763a1.435,1.435,0,0,1-1.476,1.482c-.455.019-.912,0-1.438,0v34.481c0,1.742-.4,2.145-2.149,2.145H29.484c-1.745,0-2.15-.4-2.15-2.142V299.347C26.183,299.293,24.981,299.59,24.41,298.279Zm5.908,1.092v62.911H44.924v-.91q0-10.977,0-21.956c0-1.546.459-2,1.994-2.005H63.4c1.556,0,2.016.452,2.016,1.983q0,11.014,0,22.029v.867H80.027V299.37Zm52.759,29.288V362.27H93.222V328.658ZM47.9,362.289H62.451v-21.9H47.9ZM27.369,296.337h55.6v-2.826h-55.6ZM83.056,325.65h13.1v-2.814h-13.1Z",
    transform: "translate(-15.41 -284.53)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 15.41, 284.51)",
    filter: "url(#Trac\\xE9_370)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_370-2",
    "data-name": "Trac\\xE9 370",
    d: "M43.158,308.238c0,.9.013,1.8,0,2.7-.021,1.129-.537,1.67-1.647,1.683q-2.734.03-5.468,0a1.491,1.491,0,0,1-1.672-1.669q-.024-2.734,0-5.468a1.489,1.489,0,0,1,1.622-1.65q2.77-.032,5.541,0a1.479,1.479,0,0,1,1.627,1.637c0,.048,0,.1,0,.146Q43.159,306.926,43.158,308.238Zm-5.824,1.4h2.828V306.8H37.334Z",
    transform: "translate(-16.59 -286.1)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 15.41, 284.51)",
    filter: "url(#Trac\\xE9_371)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_371-2",
    "data-name": "Trac\\xE9 371",
    d: "M47.675,308.194c0-.924-.019-1.848.005-2.771a1.449,1.449,0,0,1,1.591-1.591q2.806-.033,5.614,0a1.473,1.473,0,0,1,1.576,1.62q.029,2.771,0,5.541a1.478,1.478,0,0,1-1.642,1.623q-2.734.032-5.468,0a1.473,1.473,0,0,1-1.673-1.656C47.66,310.041,47.674,309.117,47.675,308.194Zm2.981,1.426h2.831v-2.825H50.656Z",
    transform: "translate(-18.16 -286.1)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 15.41, 284.51)",
    filter: "url(#Trac\\xE9_372)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_372-2",
    "data-name": "Trac\\xE9 372",
    d: "M83.021,308.214c0,.948.018,1.9-.006,2.844a1.421,1.421,0,0,1-1.542,1.557q-2.843.041-5.687,0a1.437,1.437,0,0,1-1.546-1.565q-.032-2.807,0-5.615a1.471,1.471,0,0,1,1.594-1.6q2.807-.034,5.615,0a1.459,1.459,0,0,1,1.573,1.609c0,.049,0,.1,0,.146Q83.022,306.9,83.021,308.214Zm-2.979,1.437v-2.833H77.209v2.833Z",
    transform: "translate(-21.3 -286.1)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 15.41, 284.51)",
    filter: "url(#Trac\\xE9_373)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_373-2",
    "data-name": "Trac\\xE9 373",
    d: "M60.966,308.239c0-.923-.009-1.847,0-2.771a1.451,1.451,0,0,1,1.546-1.633q2.843-.041,5.687,0a1.437,1.437,0,0,1,1.534,1.572q.021,2.807,0,5.614a1.424,1.424,0,0,1-1.511,1.589q-2.878.048-5.759,0a1.424,1.424,0,0,1-1.5-1.6C60.957,310.086,60.966,309.162,60.966,308.239Zm2.964,1.4h2.827V306.8H63.929Z",
    transform: "translate(-19.73 -286.1)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 15.41, 284.51)",
    filter: "url(#Trac\\xE9_374)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_374-2",
    "data-name": "Trac\\xE9 374",
    d: "M60.966,334.8c0-.924-.01-1.847,0-2.772a1.441,1.441,0,0,1,1.565-1.6q2.807-.024,5.615,0a1.447,1.447,0,0,1,1.587,1.586q.02,2.807,0,5.615a1.423,1.423,0,0,1-1.53,1.564q-2.844.028-5.688,0a1.43,1.43,0,0,1-1.55-1.546c0-.048,0-.1,0-.146Zm2.984-1.432v2.857h2.819v-2.857Z",
    transform: "translate(-19.73 -289.24)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 15.41, 284.51)",
    filter: "url(#Trac\\xE9_375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_375-2",
    "data-name": "Trac\\xE9 375",
    d: "M34.363,321.552c0-.924-.013-1.847,0-2.771a1.47,1.47,0,0,1,1.617-1.641q2.771-.032,5.541,0a1.44,1.44,0,0,1,1.627,1.619q.032,2.77,0,5.541a1.465,1.465,0,0,1-1.638,1.62q-2.734.022-5.468,0a1.514,1.514,0,0,1-1.679-1.671C34.35,323.351,34.363,322.451,34.363,321.552Zm5.8,1.421V320.12H37.354v2.852Z",
    transform: "translate(-16.59 -287.67)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 15.41, 284.51)",
    filter: "url(#Trac\\xE9_376)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_376-2",
    "data-name": "Trac\\xE9 376",
    d: "M52.1,317.134c.923,0,1.847-.017,2.77.006a1.458,1.458,0,0,1,1.593,1.591q.032,2.77,0,5.54a1.494,1.494,0,0,1-1.626,1.647q-2.771.026-5.541,0a1.445,1.445,0,0,1-1.612-1.569q-.037-2.807,0-5.614c.012-1.076.545-1.578,1.646-1.6C50.249,317.119,51.173,317.133,52.1,317.134Zm-1.445,5.807h2.842v-2.813H50.652Z",
    transform: "translate(-18.16 -287.67)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 15.41, 284.51)",
    filter: "url(#Trac\\xE9_377)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_377-2",
    "data-name": "Trac\\xE9 377",
    d: "M60.965,321.432c0-.9-.01-1.8,0-2.7a1.405,1.405,0,0,1,1.5-1.587q2.88-.042,5.759,0a1.408,1.408,0,0,1,1.507,1.584q.019,2.807,0,5.614a1.45,1.45,0,0,1-1.538,1.571q-2.843.036-5.687,0a1.45,1.45,0,0,1-1.541-1.567C60.953,323.376,60.965,322.4,60.965,321.432Zm2.987-1.332v2.857h2.816V320.1Z",
    transform: "translate(-19.73 -287.67)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 15.41, 284.51)",
    filter: "url(#Trac\\xE9_378)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_378-2",
    "data-name": "Trac\\xE9 378",
    d: "M78.689,317.137c.923,0,1.847-.02,2.771,0a1.405,1.405,0,0,1,1.553,1.537q.036,2.844,0,5.687a1.43,1.43,0,0,1-1.552,1.551q-2.843.032-5.687,0a1.444,1.444,0,0,1-1.53-1.512q-.042-2.88,0-5.76a1.422,1.422,0,0,1,1.529-1.5C76.744,317.116,77.717,317.137,78.689,317.137Zm1.36,2.991H77.2v2.817h2.845Z",
    transform: "translate(-21.3 -287.67)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 15.41, 284.51)",
    filter: "url(#Trac\\xE9_379)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_379-2",
    "data-name": "Trac\\xE9 379",
    d: "M83.021,334.844c0,.923.017,1.847-.005,2.771a1.428,1.428,0,0,1-1.591,1.577q-2.807.023-5.614,0a1.443,1.443,0,0,1-1.57-1.537q-.036-2.844,0-5.688a1.45,1.45,0,0,1,1.568-1.542q2.843-.023,5.687,0a1.405,1.405,0,0,1,1.515,1.5c.028.971.006,1.944.006,2.916Zm-5.822,1.37h2.83v-2.833H77.2Z",
    transform: "translate(-21.3 -289.24)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 15.41, 284.51)",
    filter: "url(#Trac\\xE9_380)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_380-2",
    "data-name": "Trac\\xE9 380",
    d: "M38.713,339.2c-.924,0-1.847.014-2.771,0a1.45,1.45,0,0,1-1.57-1.539q-.04-2.843,0-5.687a1.449,1.449,0,0,1,1.569-1.542q2.807-.023,5.614,0a1.411,1.411,0,0,1,1.589,1.505q.046,2.88,0,5.76a1.412,1.412,0,0,1-1.588,1.5C40.609,339.207,39.661,339.2,38.713,339.2Zm-1.386-2.987h2.858v-2.821H37.326Z",
    transform: "translate(-16.58 -289.24)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 15.41, 284.51)",
    filter: "url(#Trac\\xE9_381)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_381-2",
    "data-name": "Trac\\xE9 381",
    d: "M52.073,339.2c-.923,0-1.847.011-2.771,0a1.428,1.428,0,0,1-1.619-1.548q-.038-2.843,0-5.687a1.413,1.413,0,0,1,1.559-1.534q2.807-.024,5.614,0a1.464,1.464,0,0,1,1.6,1.586q.033,2.806,0,5.614a1.465,1.465,0,0,1-1.615,1.57C53.921,339.207,53,339.2,52.073,339.2Zm1.419-2.968v-2.837H50.667v2.837Z",
    transform: "translate(-18.16 -289.24)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImmobilIconsDash);
export default __webpack_public_path__ + "static/media/immobil-icons-dash.0ce1231f52d504a54473e4a551b8aec7.svg";
export { ForwardRef as ReactComponent };